import uniqId from 'uniq-id';

var generateId = uniqId.generateUUID('xxxxyxxxxyxxxxyxxxxyxxxxyxxxxyxxxxyxxxxy', 32);

export default {
    locations: [{
        id: generateId(),
        name: 'Main Auditorium',
        peopleIds: [],
        _collection: 'locations'
    }, {
        id: generateId(),
        name: 'Campus #2',
        peopleIds: [],
        _collection: 'locations'
    }],
    people: [{
        id: generateId(),
        name: 'Meghann Engberg',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Dede Pound',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Zada Geissler',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Luise Ellingsworth',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Nichole Bieker',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Linnea Ginsburg',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Maynard Marrone',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Dorian Suriel',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Shay Azar',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Caroyln Earley',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Angelyn Mcdougal',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Phyllis Carasco',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Dewey Mccoy',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Karry Siegal',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Oretha Bevacqua',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Kenton Goggans',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Hermelinda Quevedo',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Whitney Vanderhoff',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Arla Cupp',
        _collection: 'people'
    }, {
        id: generateId(),
        name: 'Marcene Fernald',
        _collection: 'people'
    }],
    staff: [{
        id: generateId(),
        pin: 1234,
        name: 'Bob',
        _collection: 'staff'
    }],
    dates: []
};
